import { Variant } from '@kizi/core-components';

const _default = {
  '&[type], &:not([type])': {
    bg: 'background',
    border: '1px solid',
    borderColor: 'second.1',
    borderRadius: '8px',
    color: 'text',
    fontFamily: 'body',
    fontSize: 3,
    outline: 'none',
    padding: 3,
    width: '100%',
    height: 54,
    '&:focus': {
      border: '2px solid',
      borderColor: 'main.1',
    },
    '&::placeholder': {
      color: 'placeholder',
    },
    '> svg': { fill: 'placeholder' },
  },
};

const radioMain = {
  fontSize: 2,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: 'second.0',
  mr: 2,
  '& input:checked ~ span': {
    bg: 'main.1',
    m: '0',
    width: '10px',
    height: '10px',
  },
  '&:hover': {
    bg: 'white',
    borderColor: 'main.1',
  },
  '&:focused': {
    borderColor: 'main.1',
  },
  checked: {
    borderColor: 'main.1',
    borderStyle: 'solid',
    borderWidth: '2px',
    mr: 2,
    '& input:checked ~ span': {
      bg: 'main.1',
      m: '0',
      width: '10px',
      height: '10px',
      left: 'unset',
      position: 'absolute',
    },
    '&:hover': {
      bg: 'white',
      borderColor: 'main.1',
    },
    '&:focused': {
      borderColor: 'main.1',
    },
  },
};

const radios = {
  main: radioMain,
  success: radioMain,
  error: radioMain,
};

const error = {
  ..._default,
  borderColor: 'error',
};

const success = {
  ..._default,
  // bg: 'background',
  // border: '1px solid',
  // borderColor: '#12B76A',
  // borderRadius: '8px',
  // color: 'text',
  // fontFamily: 'body',
  // fontSize: 3,
  // outline: 'none',
  // padding: 3,
  // width: '100%',
  // height: 54,
  // '&:focus': {
  //   border: '2px solid',
  //   borderColor: 'main.1',
  // },
  // '&::placeholder': {
  //   color: 'placeholder',
  // },
  // '> svg': { fill: 'placeholder' },
};

const rangeSliderInput: Variant = {
  position: 'absolute',
  width: '240px',
  height: '0',
  pointerEvents: 'none',
  outline: 'none',
};

const comparisonInput = {
  minWidth: '300px',
  bg: 'background',
  color: 'text',
  fontFamily: 'body',
  fontSize: 3,
  outline: 'none',
  height: 25,
  border: 'none',
  '&:focus': {
    border: '1px',
    borderBottomColor: 'second.0',
    borderBottomStyle: 'dashed',
  },
  '&::placeholder': {
    color: 'main.1',
    maxWidth: 'none',
    fontFamily: 'body',
    fontSize: [2, 3],
    lineHeight: 2,
    fontWeight: 0,
  },
};

const inputVariants = {
  _default,
  radios,
  error,
  success,
  rangeSliderInput,
  comparisonInput,
};

export default inputVariants;
